import Carousel from 'react-bootstrap/Carousel';
import React from 'react';
import { StyledButton, StyledCarousel, StyledSlideImage } from './styles';

function CarouselVehicleTower() {
  return (
    <StyledCarousel
      fade
      prevIcon={<StyledButton>Anterior</StyledButton>}
      nextIcon={<StyledButton>Próximo</StyledButton>}
      interval={60000}
      indicators={false}
    >
      <Carousel.Item>
        <StyledSlideImage src="/images/carousel-vehicle/1.png" alt="Fluxo de veículos - etapa 1" />
      </Carousel.Item>
      <Carousel.Item>
        <StyledSlideImage src="/images/carousel-vehicle/2.png" alt="Fluxo de veículos - etapa 2" />
      </Carousel.Item>
      <Carousel.Item>
        <StyledSlideImage src="/images/carousel-vehicle/3.png" alt="Fluxo de veículos - etapa 3" />
      </Carousel.Item>
      <Carousel.Item>
        <StyledSlideImage src="/images/carousel-vehicle/4.png" alt="Fluxo de veículos - etapa 4" />
      </Carousel.Item>
      <Carousel.Item>
        <StyledSlideImage src="/images/carousel-vehicle/5.png" alt="Fluxo de veículos - etapa 5" />
      </Carousel.Item>
      <Carousel.Item>
        <StyledSlideImage src="/images/carousel-vehicle/6.png" alt="Fluxo de veículos - etapa 6" />
      </Carousel.Item>
      <Carousel.Item>
        <StyledSlideImage src="/images/carousel-vehicle/7.png" alt="Fluxo de veículos - etapa 7" />
      </Carousel.Item>
    </StyledCarousel>
  );
}

export default CarouselVehicleTower;
